import Toggle from '@resources/js/ui/Toggle';
const navToggle = new Toggle(null, { target: '.js-navigation' });
const btnElements = document.querySelectorAll('.js-nav-btn');
btnElements.forEach(btnElement => {
    btnElement.addEventListener('click', () => navToggle.toggle());
});
